<template>
  <div>
    <VideoPlay
      v-if="isComponents"
      ref="isPComp"
      :cover="cover"
      :src="src"
      @isComponents="onParentShow"
    />
    <div class="w_1200 m_lr_auto m_t_60 p_b_100" v-else>
      <div class="m_t_100 f_s_32 c_3b3e40 f_w_600 m_b_24">视频</div>
      <div class="b_c_fff">
        <div class="f_s_16 c_3b3e40 f_w_600 p_24 b_b_1_s_f0f1f2">介绍视频</div>
        <div class="flex p_24">
          <div
            class="w_375 h_315 c_3b3e40 m_r_10 pos_r"
            v-for="item in videos.introduction"
            :key="item.label"
          >
            <div class="w_375 h_225 pos_a flex j_c_c a_i_c shangjiantou">
              <i
                class="
                  font_family
                  icon-shangjiantou
                  f_s_30
                  h_50
                  l_h_50
                  w_50
                  t_a_c
                  c_dddddd94
                  trans_90
                  b_c_00000036 b_r_100
                  cursor_p
                "
                @click="onVideoPlay(item.cover, item.src)"
              ></i>
            </div>
            <img :src="item.cover" class="w_375 h_225" />
            <div class="f_s_16">{{ item.label }}</div>
            <div class="b_c_f7f8f9 f_s_10 m_t_8 m_b_24 p_tb_3_lr_6 i-block">
              {{ item.date }}
            </div>
          </div>
        </div>
      </div>
      <div class="b_c_fff">
        <div class="f_s_16 c_3b3e40 f_w_600 p_24 b_b_1_s_f0f1f2 m_t_30">
          视频教学
        </div>
        <div class="flex p_24">
          <div
            class="w_375 h_315 c_3b3e40 m_r_10 pos_r"
            v-for="item in videos.course"
            :key="item.label"
          >
            <div class="w_375 h_225 pos_a flex j_c_c a_i_c shangjiantou">
              <i
                class="
                  font_family
                  icon-shangjiantou
                  f_s_40
                  h_50
                  l_h_50
                  w_50
                  t_a_c
                  c_dddddd94
                  trans_90
                  b_c_00000036 b_r_100
                  cursor_p
                "
              ></i>
            </div>
            <img :src="item.cover" class="w_375 h_225" />
            <div class="f_s_16">{{ item.label }}</div>
            <div class="b_c_f7f8f9 f_s_10 m_t_8 m_b_24 p_tb_3_lr_6 i-block">
              {{ item.date }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 视频展示组件
 */
import VideoPlay from "./video-play.vue";
export default {
  name: "VideoDisplay",
  components: {
    VideoPlay,
  },
  data() {
    return {
      isComponents: false,
      cover: "",
      src: "",
    };
  },
  props: {
    videos: {
      type: Object,
      default: function () {
        return {
          introduction: [],
          course: [],
        };
      },
    },
  },
  methods: {
    onVideoPlay(cover, src) {
      this.isComponents = !this.isComponents;
      this.cover = cover;
      this.src = src;
    },
    onParentShow() {
      this.isComponents = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.w_375 {
  width: 375px;
}
.h_315 {
  height: 315px;
}
.h_225 {
  height: 225px;
}
.p_tb_3_lr_6 {
  padding: 3px 6px;
}
.shangjiantou:hover {
  & > .icon-shangjiantou {
    background-color: #fbfbfb69;
    color: #e7e7e7;
  }
}
</style>